import {LoadingMessage} from '@github-ui/agent-sessions-interface/components/LoadingMessage'
import {announce} from '@github-ui/aria-live'
import type {SessionState} from '@microsoft/agent-host-protocol'
import {useEffect} from 'react'

import styles from './SessionResumeNotice.module.css'
import {getStartingMcpServerNames} from './get-starting-mcp-server-names'

export function McpLoadingNotice({customizations}: Pick<SessionState, 'customizations'>) {
  const names = getStartingMcpServerNames(customizations)
  const message = names.length > 0 ? `Loading tools from ${[...new Set(names)].sort().join(', ')}...` : undefined

  useEffect(() => {
    if (message) announce(message)
  }, [message])

  if (!message) return null

  return (
    <div className={styles.Progress} data-testid="mcp-loading-notice">
      <LoadingMessage message={message} />
    </div>
  )
}
